import { useContextSelector } from 'use-context-selector';
import { ApiProviderContext } from './SavedFareListApiProvider/Context';

export const useAddToFareList = () => {
  return useContextSelector(ApiProviderContext, (context) => context.onAddToFareList);
};
